import { useRefs } from '@/scripts/hooks';
import { safeJson } from '@/scripts/utils';
import { useSessionContext } from '@/contexts/session/context';
import type { ChatContextHooksProps } from '../../context';
import { ChatSocketControls, PushType } from '../hooks/useChatSocket/types';
import type { UserSettingsContent } from '../../../session/hooks/useUserSettings/types';

export type UseSettingsPushValueResult = ReturnType<typeof useSettingsPushValue>;

export function useSettingsPushValue({ hooks }: ChatContextHooksProps) {
  const { chatSocket } = hooks;
  const { socket, event } = chatSocket;
  const {
    userSettings: { updateUserSettingsContent },
  } = useSessionContext();

  const handleUserSettings = useCallback(
    (content: string) => {
      const settings = safeJson(content, {});
      updateUserSettingsContent(settings as UserSettingsContent);
    },
    [updateUserSettingsContent]
  );

  const refs = useRefs({
    handleUserSettings,
  });

  useLayoutEffect(() => {
    if (socket) {
      return event.onMessage(
        ({ body }) => {
          refs.current.handleUserSettings(body.content);
        },
        {
          control: ChatSocketControls.DIRECT_PUSH,
          pushType: PushType.SETTINGS,
        }
      );
    }
  }, [socket, event, refs]);

  return useMemo(() => ({}), []);
}
